;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.League = Backbone.Model.extend({
		api_prefix: '',
		final_rounds_count: null,

		isNew: function() {
			return true;
		},

		validate: function(attrs, options) {
			if (_.isUndefined(attrs.name)) {
				return 'League name cannot be empty';
			}
		},

		formAjaxCall: function(form, error_trigger, success_trigger){
			return $.ajax({
				url         : CONFIG.API_URL + this.url(),
				data        : form,
				processData : false,
				contentType : false,
				type: 'POST',
				beforeSend: function(xhr, settings) {
					var getSid = APP.getJStorage('session_id') || '';
					settings.data.append('sid', getSid );
				},
				success: _.bind(function(resp, status, xhr) {
					if (resp.errors.length) {
						this.trigger(error_trigger, resp.errors);
					}
					else {
						this.set(resp.result);
						this.trigger(success_trigger);
					}
				}, this)
			}).promise();
		},

		prepareFormData: function(data){
			
			_.each(data, function(value, key){
				if(_.isBoolean(value)){
					data[key]  = + value;
				}

				if(value && typeof value.getMonth === 'function'){
					data[key] = this.getCustomDateISOString(value);
				}
			}, this);
			var formData = new FormData();
			_.each(data, function(value,key){
				if (value instanceof File) {
					formData.append( key, value );
					return;
				}
				if(!_.isUndefined(value)){
					formData.append(key, value);
				}

			});
			return formData;
		},

		create: function(data) {
			
			var data = this.prepareFormData(data);
			return this.setApiUrl('_league/create').formAjaxCall(data, 'leagues:errors', 'leagues:create:success');
		},
		
		regenerate: function(id) {
			this.setApiUrl( '_regenerate/regenerate' ).save(null, {
				ajaxSync: true,
				data:  { id },
				success: _.bind(function(model, resp) {
					if(resp.errors.length){
						this.trigger('regenerate:errors', model, resp);
					}else {
						this.trigger('regenerate:success', model, resp);
					}
				},this)
			});
			
			return this;
		},

		update: function(data) {
			data.id = this.get('id');
			var data = this.prepareFormData(data);
			return this.setApiUrl('_league/update').formAjaxCall(data, 'leagues:errors', 'leagues:update:success');
		},

		delete: function() {
			return this.setApiUrl('_league/delete')
				.save({}, {
					data: { id: this.get('id') },
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:delete:success');
						}
					}, this)
				});
		},

		show: function() {
			return this.setApiUrl('_league/show');
		},

		show_by_id: function(league_id) {
			return this.setApiUrl('_league/show').fetch({
				data: { id: league_id }
			});
		},

		findAndFetchById: function(league_id){

			return this.setApiUrl('_league/show').fetch({
				data: { id: league_id }
			});
		},

		join: function() {
			return this.setApiUrl('_join/join')
				.save({}, {
					data: { code: this.get('code') },
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:join:success', this.get('id'));
						}
					}, this)
				});
		},

		join_by_skill: function() {
			return this.setApiUrl('_join/join_by_skill')
				.save({}, { data: {} });
		},

		leave: function(data) {
			let param = _.extend({
				league_id: this.get('id')
			}, data)
			return this.setApiUrl('_join/leave')
				.save({}, {
					data: param,
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
							this.trigger('leagues:leave:errors', resp.errors);
						}
						else {
							this.trigger('leagues:leave:success', this.get('id'));
						}
					}, this)
				});
		},
		invite: function(invites, custom_message) {
			var data = {
				league_id: this.get('id'),
				invites: invites
			};

			if (custom_message && custom_message.length > 0) data['description'] = custom_message;

			return this.setApiUrl('_join/invite')
				.save({}, {
					data: data,
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:invite:success');
						}
					}, this)
				});
		},

		send_message_teams({message, subject}){
			var data = {
				id: this.get('id'),
				subject: subject,
				text: message,
				all: 1,
			};

			return this.setApiUrl('_league/send_emails')
					   .save({}, {
						   data: data,
						   success: _.bind(function(model, resp) {
							   if (resp.errors.length) {
								   this.trigger('leagues:errors', resp.errors);
							   }
							   else {
								   this.trigger('leagues:send_message:success');
							   }
						   }, this)
					   });
		},

		remove_user: function(user_id) {
			return this.setApiUrl('_join/delete')
				.save({}, {
					data: { league_id: this.get('id'), user_id: user_id },
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:remove_coach:success', user_id);
						}
					}, this)
				});
		},

		remove_team: function(team_id) {
			return this.setApiUrl('_join/delete')
				.save({}, {
					data: { league_id: this.get('id'), team_id: team_id },
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:remove_coach:success', team_id);
						}
					}, this)
				});
		},

		setCommissioner: function(user_id) {
			//user can be a commissioner if original commissioner have added current ability
			this.set('is_commissioner', (this.get('commissioner') == user_id || this.get('user_status') == 'commissioner'));

			//specify league creator
			this.set('is_original_commissioner', this.get('commissioner') == user_id ? user_id : false);

			return this;
		},

		setFixtures: function(teams) {
			var fixtures_obj = {};

			_.each(this.get('fixture'), _.bind(function(fixture, round_id) {
				var fixture_arr = [];

				_.each(fixture, function(match) {
					var match_arr = [];

					_.each(match, function(team_id) {
						var team = teams.get(team_id);

						match_arr.push({
							id:         team.get('id'),
							name:       team.get('name'),
							user_id:    team.get('user_id'),
							team_supported: team.get('team_supported'),
							first_name: team.get('first_name'),
							last_name:  team.get('last_name'),
							scoreflow:  team.get('scoreflow')[round_id] || null,
							rank:       team.get('rank')
						});

					});

					fixture_arr.push(match_arr);

				});

				fixtures_obj[round_id] = fixture_arr;

			}, this));

			this.set('fixtures_obj', fixtures_obj);

			return this;
		},

		summ: function(a, b) {
			return parseInt(a) + parseInt(b);
		},

		getFixtureRounds: function() {

			var rounds = [],
				finals = [],
				first_final_round = this.get('end_round') - this.final_rounds_count +1,
				fixtures_keys = _.keys(this.get('fixture')) || [];

			if(this.get('finals')){
				finals = this.getFinalsNames(first_final_round);
			}


			rounds = this.generateFixtureRounds(fixtures_keys, finals);

			return rounds;
		},

		generateFixtureRounds: function(fixtures_keys, finals){
			var generated_rounds = [];
			_.each(fixtures_keys, function(value, key){
		
				if(this.getFinalRound(value, finals)){
					generated_rounds.push(this.getFinalRound(value, finals))
				}
				else {
					generated_rounds.push({id: value, name: 'Round ' + value})
				}

			}, this);



			return generated_rounds;
		},

		getFinalsNames: function(first_final_round){
			var finals_names = [];

			switch(this.final_rounds_count) {
				case 3:
					finals_names = [
						{
							id: first_final_round,
							name: 'Quarter-finals'
						},
						{
							id: first_final_round+1,
							name: 'Semi-finals'
						},
						{
							id: first_final_round+2,
							name: 'Final'
						}
					];
					break;
				case 4:
					finals_names = [
						{

							id: first_final_round,
							name: 'Qualifying finals'
						},
						{
							id: first_final_round+1,
							name: 'Semi-finals'
						},
						{
							id: first_final_round+2,
							name: 'Preliminary finals'
						},
						{
							id: first_final_round+3,
							name: 'Grand final'
						}
					];
					break;
				default:
					finals_names = false;
					break;
			}

			return finals_names;
		},

		getFinalRound: function(value, finals){

			return _.find(finals, function(val){
				return val.id == value;
			}, value);

		},

		getAvailableRounds: function(last_round) {

			var type    = this.get('type'),
				is_open = type ? type == 'open' : true;

			if (is_open) {
				return _.range(this.get('start_round'), last_round + 1);
			}

			return _.keys(this.get('fixture')) || [];
		},

		getActualRoundId: function(actual_round_id) {
			var rounds = this.getAvailableRounds(actual_round_id),
				future_rounds = rounds.filter(function(value) {
					return value >= actual_round_id;
				});

			if (future_rounds.length) {
				return future_rounds[0];
			}

			return rounds[rounds.length - 1] || null;
		},

		getSquadSize: function(){
			return this.get('squad_size') || '';
		},

		getSquadSizeArray: function(){
			var squad_size = this.getSquadSizeWithBenchArray();
			squad_size.pop();

			return squad_size;
		},

		setFinal: function(){

			this.set('is_user_make_final', this.isUserMakeFinal() );

			return this;
		},

		isUserMakeFinal: function(){

			var first_final_round = this.get('end_round') - this.final_rounds_count +1;
			
			//TODO@: Need to test
			return (this.get('final_fixture') && Boolean(this.get('next_round'))) ||  this.get('current_round') && this.get('current_round').round_id === first_final_round;
		},

		getSquadSizeWithBenchArray: function() {
			var numbersOnly = /\d+/gi;

			return this.getSquadSize().match(numbersOnly);
		},

		getTotalPlayersSize: function() {
			return this.getSquadSizeWithBenchArray().reduce(this.summ);
		},

		isType: function(type) {
			return this.get('type') == type;
		},

		coaches_box_switch_on: function(){

			return this.setApiUrl('_coaches_box/switch_on').save({}, {
					data: { league_id: this.get('id') },
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
					}, this)
				});
		},

		coaches_box_switch_off: function(){
			return this.setApiUrl('_coaches_box/switch_off').save({}, {
				data: { league_id: this.get('id') },
				success: _.bind(function(model, resp) {
					if (resp.errors.length) {
						this.trigger('leagues:errors', resp.errors);
					}
				}, this)
			});

		},

		edit_users: function(params) {
			return this.setApiUrl('_join/edit_users')
				.save({}, {
					data: params,
					success: _.bind(function(model, resp) {
						if (resp.errors.length) {
							this.trigger('leagues:errors', resp.errors);
						}
						else {
							this.trigger('leagues:edit_users:success', {});
						}
					}, this)
				});
		},

		setLeagueAvatarUrl: function(){
			this.set('league_avatar', this.getUploadedAvatarUrl());
		},

		getUploadedAvatarUrl: function(){
			var avatar_version = this.get('avatar_version');
			if(!avatar_version){
				return CONFIG.IMAGES_URL+'nouserpic.png';
			}
			//
			return CONFIG.LEAGUE_AVATAR_URL + this.get('id') + '.png?' + avatar_version;
		}

	});

}(window, APP, Backbone, Marionette, $, _));